// Reusable "this content is not final yet" shimmer for in-place panels inside an already-visible screen —
// a tab sub-panel, a row, a field that hydrates after its container.
//
// loading-bar-top remains the default for whole-page / whole-section loads. Reach for mat-skeleton only
// when a region is EMPTY and about to be filled, or when the real control would otherwise render a value
// it does not yet know. Never swap one in for content already on screen and taller than the bars:
// replacing a tall panel with short bars collapses the document, so everything below slides up and back
// for the length of the request. Dim that content in place instead — opacity + `inert`, see
// .sponsor-reveal-authoring .is-refreshing in css/mat/main.scss.
//
// Pair it with ng-show, not ng-if, beside Trumbowyg-bearing or otherwise stateful markup: ng-if tears
// that sibling state down and rebuilds it on every flag flip.
//
// Styling is entirely Bootstrap 5.3.8's .placeholder / .placeholder-glow (already vendored), so this
// ships no CSS beyond the prefers-reduced-motion override in css/mat/animations.scss.
//
// Usage:
//   <div data-mat-skeleton data-lines="2" data-label="Refreshing sponsor settings"></div>
//   <span data-mat-skeleton data-inline="true" data-widths="[4, 3]"></span>
app.directive('matSkeleton', ['portalHelper', function (portalHelper) {
  const DEFAULT_BAR_WIDTHS = [12, 10, 8, 6];
  const DEFAULT_BAR_COUNT = 2;

  return {
    restrict: 'A',
    // A child scope, deliberately not an isolate one: this directive is designed to sit on the same
    // element as ng-show, and an isolate scope would not be shared with it. Prototypal inheritance keeps
    // the caller's own expressions resolving while still giving each instance its own barWidths.
    scope: true,
    templateUrl: portalHelper.getUrlRev('html_templates/directives/mat_skeleton.86f07ad8.html'),
    link: function (scope, element, attrs) {
      // Announce the region as a polite live status, unless the caller already said how it should behave.
      if (!element.attr('role')) {
        element.attr('role', 'status');
      }
      if (!element.attr('aria-live')) {
        element.attr('aria-live', 'polite');
      }

      // scope.$eval is AngularJS's own expression parser (the same one ng-show/ng-if use), not JavaScript
      // eval() — it evaluates an Angular expression against this scope and cannot reach arbitrary code.
      // Values come from the template's own attributes, i.e. developer-authored markup, never user input.
      scope.isInline = scope.$eval(attrs.inline) === true;

      attrs.$observe('label', function (value) {
        scope.skeletonLabel = value || 'Loading';
      });

      // Read the bar configuration once at link time rather than watching it. The shape of a skeleton is
      // static in every real use, and a watcher would fire on every digest for callers who pass an inline
      // array literal (a new array each time).
      const widths = scope.$eval(attrs.widths);
      const barCount = scope.$eval(attrs.lines) || widths?.length || DEFAULT_BAR_COUNT;
      const bars = [];

      for (let i = 0; i < barCount; i++) {
        bars.push(widths?.[i] || DEFAULT_BAR_WIDTHS[i % DEFAULT_BAR_WIDTHS.length]);
      }

      scope.barWidths = bars;
    }
  };
}]);
